<template>
  <div class="live">
  

      <div style="width:100%; display:block;">
          <div class="col-md-4">
              <h3 v-text="data.name"></h3>
              <div class="btn">שידור חי</div>
              <p v-html="data.details"></p>
          </div>
          <div class="col-md-8">
             <!-- <div class="pic" :style="'background-image:url('+ pic +')'"><i class="fas fa-play-circle"></i></div> -->
              
        
        











    <div id="video_wrapper" @mouseover="show_controls = true" @mouseleave="show_controls = false">
      

          

          <video ref="videoPlayer" class="video-js" autoplay>
          </video>

    </div>









          </div>
      </div>
    

  </div>
</template>
<style lang="scss" scoped>
.live{
    &{padding-top: 0px;height: 100vh;}
    .col-md-4{padding-left: 0;padding-top: 100px;padding-right: 50px;}
    .col-md-8{padding-right: 0;}
    .pic{height: 100vh;width: 100%;text-align: center;position: relative;background-position: center;background-size: cover;}
    .fa-play-circle{font-size: 100px;color: #dd1a7b;position: absolute;left: 0;right: 0;margin: 0 auto;top: 40%;}
    .fa-play-circle:hover{transform: scale(1.1);}
    h3{font-size: 40px;margin-bottom: 50px;}
    .btn{margin-bottom: 30px;}
    p{font-size: 22px;}
    .video-js{    height: 100vh;
    width: 100%;}
}
</style>
<script>
 
import videojs from 'video.js';
import 'videojs-hotkeys';
//import { clearTimeout } from 'timers';

require('video.js/dist/video-js.min.css');

export default {
  components: {  },

  data() {
    return {
      data: [],
      promoted: [],
      categories: [], 
      category: [], 
        id: this.$route.params.id,

      player: null,
      loaded: false,
      videoOptions: {
        //language: 'he',
        //poster: this.episode.pic_thumb_parsed,
        autoplay: true, // (this.$route.query.autoplay == 'true'),
				controls: true,
				sources: [
					{
						src: '', // this.episode.video,
						type: "video/mp4"
          }
          /*,
          {
            src: 'https://www.iandevlin.com/html5test/webvtt/upc-video-subtitles-en.vtt',
            type: ''
          }*/
				]
      },


    };
  },

  updated: function () {
      window.dispatchEvent(new Event('resize'));

  },
  created() {

    this.$emit('show_loader');

    var self = this;

    // categories
    this.api_call({ url: 'live', data: { id: this.id }, onComplete: function(data){
      // promoted
     
      self.data = data.data.data.live;
      self.pic = data.data.data.pic;
      self.$emit('loaded');

    



      self.videoOptions.poster = self.pic;
      self.videoOptions.sources = [
        { 
          src: (self.data.link != '' ? self.data.link : ''),
          type: (self.data.link.search('m3u8') != -1 ? "application/x-mpegURL" : 'video/mp4')
        }
      ];

     // self.videoOptions.plugins = { newButton : {} };

      self.videoOptions.controlBar= {
              children: [
                  'progressControl',
                  //'VolumePanel',
                  'CurrentTimeDisplay',
                  'TimeDivider',
                  'DurationDisplay',
                  'ProgressControl',
                  'LiveDisplay',
                 // 'SeekToLive',
                  'RemainingTimeDisplay',
                  'CustomControlSpacer',
                  'PlaybackRateMenuButton',
                  'ChaptersButton',
                  'DescriptionsButton',
                  //'SubsCapsButton',
                  'AudioTrackButton',
                  //'PictureInPictureToggle',
                  //'FullscreenToggle',
              ]
          }
  


      self.player = videojs(self.$refs.videoPlayer, self.videoOptions, function onPlayerReady() {
         // console.log('onPlayerReady', this);

        self.player.on('timeupdate', function(){ 
          
          self.user_watch_time = self.currentTime;

        });

      });


    // LEFT GROUP 
    self.player.controlBar.left_group = self.player.controlBar.addChild('Component');
    self.player.controlBar.left_group.addClass('left_group');

    //self.player.controlBar.left_group.addChild(new info_btn()).addClass('info-btn');
    self.player.controlBar.left_group.addChild('FullscreenToggle');
    if (!self.is_mobile()) self.player.controlBar.left_group.addChild('PictureInPictureToggle');
    self.player.controlBar.left_group.addChild('SubsCapsButton');
    if (!self.is_mobile()) self.player.controlBar.left_group.addChild('VolumePanel');

    self.player.controlBar.el().append(
      self.player.controlBar.left_group.el(),
      self.player.controlBar.el().firstChild.nextSibling
    );


    // CENTER GROUP
    self.player.controlBar.center_group = self.player.controlBar.addChild('Component');
    self.player.controlBar.center_group.addClass('center_group');

    
    self.player.controlBar.center_group.addChild('PlayToggle');

    self.player.controlBar.el().append(
      self.player.controlBar.center_group.el(),
      self.player.controlBar.el().firstChild.nextSibling
    );



    // RIGHT GROUP
    self.player.controlBar.right_group = self.player.controlBar.addChild('Component');
    self.player.controlBar.right_group.addClass('right_group');

 //   self.player.controlBar.right_group.addChild(new episode_name()); 


    self.player.controlBar.el().append(
      self.player.controlBar.right_group.el(),
      self.player.controlBar.el().firstChild.nextSibling
    );

//console.log(self.player.controlBar)


      self.loaded = true;
      self.$emit('loaded');
 
    }});
      
  },
  computed:{
      
    currentTime: {
      // getter
      get: function () { 
        //console.log(this.player.currentTime())
        return this.player.currentTime();
      },
      // setter
      set: function (newValue) {
        this.player.currentTime(newValue);
      }

    },
  },

  methods:{
      
    user_hover(){
      var self = this;
      self.is_user_active = true;

      window.clearTimeout(this.is_user_active_timer);

      this.is_user_active_timer = setTimeout(() => {
        self.is_user_active = false;
      }, 2400);
    },


  },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    },
}
</script>